// extracted by css-extract-rspack-plugin
var _1 = "n7";
var _2 = "n6";
export { _1 as "pageContent", _2 as "verificationPageComponent" }
